import { render, staticRenderFns } from "./EditarIpg.vue?vue&type=template&id=5a35ebe5&scoped=true"
import script from "./EditarIpg.vue?vue&type=script&lang=js"
export * from "./EditarIpg.vue?vue&type=script&lang=js"
import style0 from "./EditarIpg.vue?vue&type=style&index=0&id=5a35ebe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35ebe5",
  null
  
)

export default component.exports